import { render, staticRenderFns } from "./CompanyEventModal.vue?vue&type=template&id=520fcdde&scoped=true"
import script from "./CompanyEventModal.vue?vue&type=script&lang=js"
export * from "./CompanyEventModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyEventModal.vue?vue&type=style&index=0&id=520fcdde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520fcdde",
  null
  
)

export default component.exports